import { $Q, $Qll } from '../utils/querySelector';
import { getCookie } from '../utils/cookie';

window.document.addEventListener('DOMContentLoaded', () => {

  initLogout();

  const menu = $Q('.account__menu.mobile');

  if (menu) {
    const menuItemsList = $Q('ul', menu);
    const activeLink = $Q('.active', menu);

    const activeLinkCopy = activeLink.cloneNode(true);
    menuItemsList.prepend(activeLinkCopy);

    activeLink.remove();

    $Q('svg', activeLinkCopy).addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      menu.classList.toggle('shown');
    });
  }

  /**
   * This function clean the dcCodes cookie and redirect to logout page
   * @author Sebastian García <sebastian.garcia@gradiweb.com>
   * @team Support
   */

  function initLogout() {
    const links = $Qll('.account-menu-link--logout');
    if (links.length > 0) {
      links.forEach(link => {
        const href = link.dataset.hreflink;
        link.addEventListener('click', () => {
          const dcCodesCookie = getCookie("dcCodes");
          if (dcCodesCookie) {
            document.cookie = "dcCodes=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          }
          window.location.href = href;
        });
      });
    }
  }
  
});
